import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { getContentByCategory } from '../services/api';

// Extracts a YouTube video ID from common URL formats (watch?v=, youtu.be/, embed/)
function getYouTubeEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

export default function PodcastCentre() {
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    getContentByCategory('PODCAST')
      .then((res) => setEpisodes(res.data))
      .catch(() => setEpisodes([]));
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Podcast Centre"
        title="Conversations On Workers' Rights"
        subtitle="Episodes, videos and educational content from the Spear Of Workers team."
      />
      <section className="section">
        <div className="container">
          {episodes.length === 0 ? (
            <div className="card">
              <p>New episodes are on the way. Check back soon, or follow our social channels for updates.</p>
            </div>
          ) : (
            <div className="grid grid-3">
              {episodes.map((e) => {
                const embedUrl = getYouTubeEmbedUrl(e.mediaUrl);
                return (
                  <div className="card" key={e.id}>
                    {embedUrl ? (
                      <div style={{ position: 'relative', paddingTop: '56.25%', marginBottom: 16, borderRadius: 4, overflow: 'hidden' }}>
                        <iframe
                          src={embedUrl}
                          title={e.title}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                        />
                      </div>
                    ) : e.imageUrl ? (
                      <img
                        src={e.imageUrl}
                        alt={e.title}
                        style={{ width: '100%', height: 180, objectFit: 'cover', borderRadius: 4, marginBottom: 16 }}
                      />
                    ) : null}
                    <h3>{e.title}</h3>
                    <p>{e.content}</p>
                    {e.mediaUrl && !embedUrl && (
                      <a href={e.mediaUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark" style={{ marginTop: 12 }}>
                        Listen / Watch
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
